<script>
import Layout from "../../layouts/auth";
import { authMethods } from "@/state/helpers";
import appConfig from "@/app.config";
import moment from "moment";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import { required, maxLength, minLength, email } from "vuelidate/lib/validators";

/**
 * Forgot Password component
 */
export default {
  mixins: [apibtoast, apigeneric],
  page: {
    title: "Forgot Password",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      cepNo: "",
      submitted: false,
      error: null,
      tryingToReset: false,
      isResetError: false,
      Senddate: null,
      OSmsVerificationPostSonucu: null,
      Verifycode: null,
      NewPassword: "",
      NewPasswordConfirm: "",
      SmsSorgu: null,
      cepNoGizle: null,
      ChangeSuccessfull: false,
      passwordtype: true,
      email: "",
      Page: {
            PageNumber: "1",
            PageSize: "10",
            PageDataSize: "1",
          },
    };
  },
  validations: {
    cepNo: {
      required,
      maxLength: maxLength(10), minLength: minLength(10),
    },
    email: {
      required,
      email
     }
  },
  methods: {
    ...authMethods,
    tryToReset() {
      var Filter = "&Eposta=" + this.email;
      this.ActionsFilterGet({"Service": this.$config.API_URL_2 + "mznmezunlar", "Page":this.Page,Filter: Filter ,}).then(
          (res) => {
      if(parseFloat(res.Data[0].Telefon) === parseFloat(this.cepNo)){
      this.submitted = true;
        this.Senddate = moment(new Date()).format("YYYY-MM-DDTHH:mm:ss") + "Z";
      var FormData = {
        "Recipientphone": this.cepNo,
        "Senddate": this.Senddate
      }
      this.ActionsPost({ Service: "OSmsVerification/forgot-password-sms", Data: FormData }).then(
        (res) => {
          if (res.Succeeded == true) {
                this.$toast.success('SMS Gönderildi');
                this.OSmsVerificationPostSonucu = res;
          } else {
            this.$toast.error("SMS Gönderilemedi");
          }
        })
                
      }else{
        this.$toast.error("Sistemde kayıtlı e-posta ile telefon numarası uyuşmamaktadır");
      }
                  
          });
    },
    OSmsVerificationSorgu() {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      this.ActionsFilterGet({
        Service: "OSmsVerification",
        Page: Page,
        Filter: "&Recipientphone=" + this.cepNo +
          "&Senddate=" + this.Senddate +
          "&Verifycode=" + this.Verifycode
      }).then((OSmsVerification) => {
        if (OSmsVerification && OSmsVerification.Data.length > 0) {
          this.OSmsVerification = OSmsVerification.Data[0]
          this.$toast.success("SMS Doğrulama Başarılı");
          this.SmsSorgu = true;
          this.OSmsVerificationPostSonucu = null;
          this.cepNoGizle = true;

        } else {
          this.$toast.error("SMS Doğrulama Başarısız!");
        }

      })

    },
    ChangePassword(){
      if(this.NewPasswordConfirm == this.NewPassword){
        var FormData = {
          Email : this.email,
          Password : this.NewPassword
        }
        this.ActionsPost({ Service: this.$config.API_ACCOUNT_URL+"Account/change-password?Email=" + this.email + "&Password=" + this.NewPassword }).then(
        (res) => {
          if (res.Succeeded == true) {
                this.$toast.success('Şifre Başarıyla Değiştirildi');
                this.ChangeSuccessfull = true; //:)
          } else {
            console.log(FormData)
            this.$toast.error("Şifre Değiştirilemedi!");
          }
        })
      }else{
        this.$toast.error("Girdiğiniz Şifreler Aynı Değil!");
      }
    }
  },
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Şifre Sıfırlama</h5>
                  <p>Mezun Bilgi Sistemi Şifre Sıfırlama</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img
                  src="@/assets/images/logo-light.png"
                  alt
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <router-link tag="a" to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="@/assets/images/logo-light.png" alt height="34" />
                  </span>
                </div>
              </router-link>
            </div>

            <div class="p-2">
              <b-alert
                v-model="isResetError"
                class="mb-4"
                variant="danger"
                dismissible
                >{{ error }}</b-alert
              >
              <form @submit.prevent="tryToReset" v-if="ChangeSuccessfull != true">
                <div class="mb-3" v-if="!cepNoGizle">
                  <div class="mb-3">
                  <label for="useremail">Email</label>
                  <input
                    type="email"
                    v-model="email"
                    class="form-control"
                    id="useremail"
                    placeholder="Sistemde Kayıtlı Mail Adresinizi Girin"
                    :class="{ 'is-invalid': submitted && $v.email.$error }"
                  />
                  <div
                    v-if="submitted && $v.email.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="!$v.email.required">Email adresi gerekli.</span>
                    <span v-if="!$v.email.email"
                      >Lütfen geçerli bir mail adresi giriniz.</span
                    >
                  </div>
                </div>
                  <label for="usercepNo">Cep Telefonu</label>
                  <input
                    v-model="cepNo"
                    class="form-control"
                    id="usercepNo"
                    placeholder="Sistemde Kayıtlı 10 Haneli Telefon Numaranızı Girin"
                  />
                  <div
                    v-if="submitted"
                    class="invalid-feedback"
                  >
                    <span v-if="!$v.cepNo.required">Cep numarası giriniz.</span>
                    <span v-if="!$v.cepNo.maxLength || !$v.cepNo.minLength"
                      >Lütfen bir cep telefonu numarası giriniz.</span
                    >
                  </div>
                  <div class="col-12 text-end mt-3">
                    <button class="btn btn-primary w-md" type="submit">
                      Doğrulama Kodu
                    </button>
                  </div>
                </div>
                <div class="mb-3 row mb-0" v-if="OSmsVerificationPostSonucu">
                  <div class="col-sm-1"></div>
                  <div class="col-sm-6">
                    <b-form-group v-if="OSmsVerificationPostSonucu" label="Sms Kodunuz" label-for="text">
                      <b-form-input v-model="Verifycode" for="text" type="number"></b-form-input>
                    </b-form-group>

                  </div>
                  <div class="col-sm-4 mt-4"> <b-button-group>
                      <button class="btn btn-primary w-md" type="button" v-if="OSmsVerificationPostSonucu"
                        @click="OSmsVerificationSorgu()">
                        Gönder
                      </button>
                    </b-button-group>
                  </div>
                </div>
                <div v-if="OSmsVerificationPostSonucu == null && cepNoGizle == true">
                  <div class="col-sm-12">
                    <b-form-group label="Yeni Şifre" label-for="text">
                      <b-form-input v-model="NewPassword" for="text" :type="passwordtype == true ? 'password' : 'text'"></b-form-input>
                    </b-form-group>
                    <b-form-group label="Şifreyi Tekrarla" label-for="text">
                      <b-form-input v-model="NewPasswordConfirm" for="text" :type="passwordtype == true ? 'password' : 'text'"></b-form-input>
                    </b-form-group>
                    <i class="fas fa-eye" @click="passwordtype == true ? passwordtype = false : passwordtype = true"  ></i>
                  </div>
                  <div class="col-sm-4 mt-4"> <b-button-group>
                      <button class="btn btn-primary w-md" type="button"
                        @click="ChangePassword()">
                        Şifreyi Yenile
                      </button>
                    </b-button-group>
                  </div>
                </div>


              </form>
              <h3 v-if="ChangeSuccessfull" style="color: #0D6EFD; text-align: center;">Şifre Değişikliği Başarılı</h3>
            </div>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
          <p>
            Hatırladınız Mı ?
            <router-link
              tag="a"
              to="/login"
              class="fw-medium text-primary"
              >Giriş Ekranı</router-link
            >
          </p>
          <p>
            © {{ new Date().getFullYear() }} by Elasoft Yazılım ve Bilişim Teknolojileri
          </p>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
